import { ElementProps } from '@/components/sections/builder/types';
import { getOverrideAnimationParams } from '@/components/sections/builder/settings/animation-setting';
import clsx from 'clsx';
import { ProductDetailTitleElementDataType } from '@/components/sections/builder/elements/body/product-detail/type';
import { Type } from 'lucide-react';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/vanilla/shallow';
import React from 'react';
import { IProduct } from '@/types/product';
import { cn, isEmpty } from '@/lib/utils';
import { ElementDataType } from '@/components/sections/builder/elements/body/product-detail/type';
import InputSelect from '@/components/sections/builder/settings/input-select';

const defaultData: ProductDetailTitleElementDataType = {
  name: 'Title',
  label: 'Product A',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ProductDetailTitleElementDataType;
  const parentData = (element.parentData || {}) as IProduct;
  const content = element.parentData as ElementDataType;
  return (
    <div className='flex flex-col'>
      <span
        className={cn(
          'theme_font text_product_secondary text-xs text-gray-500',
          data.textStyle === 'body' && 'sm:text-sm md:text-base lg:text-lg',
          (data.textStyle === 'subtitle' || !data.textStyle) &&
            'text-xs sm:text-xs md:text-sm lg:text-base',
          data.textStyle === 'uppercase' && 'text-xs uppercase sm:text-xs md:text-sm lg:text-base'
        )}
      >
        {parentData.category_name}
      </span>
      <h1
        data-animation='true'
        {...getOverrideAnimationParams(data.animation)}
        className={clsx(
          'theme_font_heading break-words font-bold',
          data.textStyle === 'body' && 'text-base md:text-lg lg:text-xl',
          (data.textStyle === 'subtitle' || !data.textStyle) && 'text-sm md:text-base lg:text-lg',
          data.textStyle === 'uppercase' && 'text-base uppercase md:text-base lg:text-lg'
        )}
        style={
          !isEmpty(content.colorSchemeProductDetail)
            ? {
                color: content?.colorSchemeProductDetail?.text,
              }
            : {}
        }
      >
        {parentData.product_name}
      </h1>
    </div>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as ProductDetailTitleElementDataType;

  return (
    <React.Fragment>
      <div className='my-4 grid grid-cols-2 items-center gap-2'>
        <h4 className=''>Text Style</h4>
        <InputSelect
          defaultValue={data.textStyle || 'subtitle'}
          options={[
            { label: 'Body', value: 'body' },
            { label: 'Subtitle', value: 'subtitle' },
            { label: 'UPPERCASE', value: 'uppercase' },
          ]}
          onChange={(v) =>
            builder.setChildData(element.parentId as string, element.id, {
              textStyle: v,
            })
          }
        />
      </div>
    </React.Fragment>
  );
}

const ProductDetailTitle = {
  type: 'title',
  group: 'product_detail',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default ProductDetailTitle;
